export default ({store, redirect}) => {
  if (!store.state.auth.loggedIn || (!store.state.auth.user.is_admin && !store.state.auth.user.commissie)) {
    return redirect('/');
  }
};
